import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  apelacion_selected: {}, //seleccionara el objeto de la lista de magistrados
  apelaciones: []
};
export const mutations = {
  SELECT_APELACION({ context }, apelacion) {
    return (state.apelacion_selected = Object.assign({}, apelacion));
  },
  FILL_APELACIONES({ context }, list_apelaciones) {
    let apelaciones = [];
    Object.entries(list_apelaciones).forEach(([key, val]) => apelaciones.push(val));
    return (state.apelaciones = apelaciones);
  },

};

export const actions = {
  GET_APELACIONES({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("FILL_APELACIONES", response.data.data.apelaciones.data);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  UPDATE_APELACION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.put(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  CREATE_APELACION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.guardar(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SHOW_APELACION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("SHOW_APELACION", response.data.data.apelacion);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  CREATE_PREVISUALIZACION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.post(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  UPDATE_PREVISUALIZACION({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.put(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  GET_PREVISUALIZACIONES({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("GET_PREVISUALIZACIONES", response.data.data.apelaciones.data);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  ASIGNA_RELATOR({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.put(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },

  GET_DOCUMENTO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.getDocumento(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};
export const getters = {
  getAllApelaciones: state => {
    return state.apelaciones;
  },
  getApelacionSelected: state => {
    return state.apelacion_selected;
  },
};
